import supplyModule from "./supplyModule"

const SUPPLY_MODE_KEY = "supply-mode"
const ROUTING_SESSION_KEY = "routing-session-identifier"

supplyModule.service("supplyService", ["$localStorage", "permissionService", function ($localStorage, permissionService) {
    const self = this


    const clearStorageKey = (key) => {
        delete $localStorage[key]
    }

    this.isSupplyMode = () => !!$localStorage[SUPPLY_MODE_KEY]

    this.activateSupplyMode = () => {
        $localStorage[SUPPLY_MODE_KEY] = true
    }

    this.inactivateSupplyMode = () => {
        clearStorageKey(SUPPLY_MODE_KEY)
        clearStorageKey(ROUTING_SESSION_KEY)
    }

    this.isRoutingSessionRestricted = () => !!$localStorage[ROUTING_SESSION_KEY]
    this.getRoutingSessionRestrictedName = () => $localStorage[ROUTING_SESSION_KEY]

    this.getRoutingSessionIdentifier = () => $localStorage[ROUTING_SESSION_KEY]

    this.restrictSession = (identifier) => {
        if (identifier) {
            $localStorage[ROUTING_SESSION_KEY] = identifier
        }
    }


    /**
     * Monitora o carregamento das APIs de baskets e dispara a busca inicial
     * caso a sessão seja restrita.
     */
    this.registerInitialSearchWatch = (scope, baskets) => {
        const unregister = scope.$watch(
            () => baskets.trips?.forceSearch && baskets.orders?.forceSearch,
            (isReady) => {
                if (!isReady) return

                unregister()

                if (self.isRoutingSessionRestricted()) {
                    baskets.trips.forceSearch()
                    baskets.orders.forceSearch()
                }
            }
        )
    }

    this.isSupplyProfile = () => {
        return permissionService.canRead("group.r2.supply.mode")
    }

}])